<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M6 18C8.20914 18 10 16.2091 10 14C10 11.7909 8.20914 10 6 10C3.79086 10 2 11.7909 2 14C2 16.2091 3.79086 18 6 18Z"
        :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
        d="M18 18C20.2091 18 22 16.2091 22 14C22 11.7909 20.2091 10 18 10C15.7909 10 14 11.7909 14 14C14 16.2091 15.7909 18 18 18Z"
        :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
        d="M10 14L10.211 13.894C10.7665 13.6162 11.379 13.4716 12 13.4716C12.621 13.4716 13.2335 13.6162 13.789 13.894L14 14M19 6L21.838 12.623C21.9448 12.872 21.9999 13.1401 22 13.411V14M5 6L2.162 12.623C2.05532 12.8717 2.00021 13.1394 2 13.41V14"
        :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
};
</script>